module.exports = __webpack_public_path__ + "static/img/logo27.f372150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo27.jpg
// module id = iEqF
// module chunks = 1